/**
 * Image Copy Section H image parallax effect
 */

export default {
    init() {
        if (document.querySelector('.section--image-copy')) {
            document.querySelectorAll('.section--image-copy')
                .forEach(el => {
                    let pic = el.querySelector('picture');
                    let img = pic.querySelector('img');

                    if (img.classList.contains('lazyload')) {
                        img.addEventListener('lazyloaded', () => this.initParallax(el));
                    } else {
                        this.initParallax(el)
                    }
                });
        }
    },
    /**
     * Calculate the relative clip-path
     *
     * @param coordinates
     * @returns {string}
     */
    calcRelativePath(coordinates) {
        // todo: make path relative
        // `polygon(${lx}% 0px, ${rx}% 0px, ${rx}% 100%, ${lx}% 100%)`;

        let w = 622, h = 622;
        let points = coordinates.map(({x, y}) => `${Math.round(x / w * 100)}% ${Math.round(y / h * 100)}%`);
        let path = `polygon(${points.join(', ')})`;

        return path;
    },
    /**
     * Calculate coordinates from single point, width, and height
     *
     * @returns {[{x, y},{x: *, y},{x: *, y: *},{x, y: *}]} Array of points
     */
    calcCoordinates({x, y, w, h})  {
        return [
            { "x": x, "y": y },
            { "x": x + w, "y": y },
            { "x": x + w, "y": y + h },
            { "x": x, "y": y + h }
        ];
    },
    calcParallaxCoordinates({x, y, w, h}, img, direction = 'down') {

        const clamp = (number, min = 0, max = 1) => Math.max(min, Math.min(number, max));

        let min = 0, max = 622;
        let x2 = x;
        let y2 = y;

        let rh = (window.innerHeight - (img.getBoundingClientRect().top + (img.offsetHeight / 2))) / window.innerHeight;
        rh = clamp(rh); // Prevent clip from going out of bounds

        switch (direction) {
            case 'up':
                y2 -= (max - h) * rh * 0.5;
                break;
            case 'down':
                y2 += (max - h) * rh;
                break;
            case 'left':
                x2 -= (max - w) * rh * 0.5;
                break;
            case 'right':
                x2 += (max - w) * rh;
                break;
        }

        return [
            { "x": x2, "y": y2 },
            { "x": x2 + w, "y": y2 },
            { "x": x2 + w, "y": y2 + h },
            { "x": x2, "y": y2 + h }
        ];
    },
    /** Clip image path */
    clipImagePath(img, orientation) {
        let points;
        let direction = 'down';

        if (orientation === 'horizontal') {

            if (img.classList.contains('parallax-leftside')) {
                points = { "x": 97, "y": 66, "w": 525, "h": 205 };
                direction = 'left';
            } else {
                points = { "x": 0, "y": 351, "w": 525, "h": 205 };
                direction = 'right';
            }
        } else {
            if (img.classList.contains('parallax-leftside')) {
                points = { "x": 66, "y": 97, "w": 205, "h": 525 };
                direction = 'up';
            } else {
                points = { "x": 351, "y": 0, "w": 205, "h": 525 };
                direction = 'down';
            }
        }

        let coordinates = this.calcParallaxCoordinates(points, img, direction);
        let path = this.calcRelativePath(coordinates);

        img.style.clipPath = path;
    },
    initParallax(container) {
        let pic = container.querySelector('picture');

        // Create Parallax Elements
        let leftSide = pic.cloneNode(true);
        let rightSide = pic.cloneNode(true);

        leftSide.classList.add('parallax-leftside');
        rightSide.classList.add('parallax-rightside');

        pic.insertAdjacentElement('afterend', rightSide);
        pic.insertAdjacentElement('afterend', leftSide);

        // Hide the original image
        pic.style.visibility = 'hidden';

        let orientation = container.dataset.imageOrientation ?? 'vertical';
        this.clipImagePath(leftSide, orientation);
        this.clipImagePath(rightSide, orientation);

        // todo: add listener update clip path on scroll event
        window.addEventListener('scroll', e => {
            this.clipImagePath(leftSide, orientation);
            this.clipImagePath(rightSide, orientation);
        });
    }
}
